<div *ngIf="formGroup" class="card-container mt-4">
  <form [formGroup]="formGroup">
    <div>
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-4 lg:col-3">
              <label for="specieName">
                {{'AdminSpeciesManagement.CreateEditSpecie.SpanishSpecieNameText' | translate}}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="specieName"
                pInputText
                placeholder="{{'AdminSpeciesManagement.CreateEditSpecie.SpanishSpecieNameText' | translate}}"
                formControlName="nameEs"
                class="custom-input">
              <small *ngIf="submit && formGroup.controls['nameEs'].invalid"
                class="p-error">{{getErrorMessage()}}</small>
            </div>

            <div class="field col-12 md:col-4 lg:col-3">
              <label for="specieName">
                {{'AdminSpeciesManagement.CreateEditSpecie.EnglishSpecieNameText' | translate}}
                <span class="mandatory-field">*</span>
              </label>
              <input
                id="specieName"
                pInputText
                placeholder="{{'AdminSpeciesManagement.CreateEditSpecie.EnglishSpecieNameText' | translate}}"
                formControlName="name"
                class="custom-input">
              <small *ngIf="submit && formGroup.controls['name'].invalid"
                class="p-error">{{getErrorMessage()}}</small>
            </div>

            <div class="flex col-12">
              <p-fileUpload
                #fileUploader
                [showUploadButton]="false"
                [multiple]="false"
                accept=".jpg, .jpeg, .png"
                name="img"
                [maxFileSize]="5000000"
                chooseLabel="{{'AdminSpeciesManagement.CreateEditSpecie.LoadButton' | translate}}"
                cancelLabel="{{'AdminSpeciesManagement.CreateEditSpecie.CancelButton' | translate}}"
                (onSelect)="onSelect($event)"
                class="custom-text-button file-uploader">
                <ng-template pTemplate="content" let-files>
                  <div *ngIf="species?.imageUrl && uploadedFiles.length === 0"
                    class="flex flex-row justify-content-between align-content-center align-items-center">
                    <div class="flex align-content-center align-items-center">
                      <img
                        [src]="species?.imageUrl | speciesImageUrl"
                        [alt]="species?.name"
                        class="detail-image"/>
                      <span class="pl-8">{{ species?.name }}</span>
                    </div>

                    <p-button
                      icon="pi pi-times"
                      class="custom-button"
                      (onClick)="removeImage()"/>
                  </div>
                </ng-template>
              </p-fileUpload>
            </div>
        </div>

        <h3 class="w-12 text-xl font-medium text-800 mb-5">Agregar Variedades</h3>
        <form [formGroup]="varietyForm">
        <div class="p-fluid formgrid grid">

          <div class="field col-12 md:col-4 lg:col-3">
            <input
              pInputText
              formControlName="name"
              placeholder="Nombre variedad"
              formControlName="name"
              class="custom-input">
              <small *ngIf="submit && formGroup.controls['name'].invalid" class="p-error">{{getErrorMessage()}}</small>
          </div>

          <div class="field col-12 md:col-4 lg:col-6">
              <p-fileUpload
                #fileUploaderVariety
                [multiple]="false"
                mode="basic"
                accept=".jpg, .jpeg, .png"
                name="img"
                [maxFileSize]="5000000"
                chooseLabel="{{'AdminSpeciesManagement.CreateEditSpecie.LoadButton' | translate}}"
                (onSelect)="onFileSelect($event)"
                class="custom-text-button">
              </p-fileUpload>
          </div>

          <div class="field col-12 md:col-4 lg:col-2">
            <p-button
              icon="pi pi-plus"
              label="Agregar"
              styleClass="w-8rem"
              class="custom-text-button"
              (click)="addVariety()">
            </p-button>
          </div>
        </div>
        </form>
    </div>

    <p-table [value]="varieties.controls">

      <ng-template pTemplate="header">
        <tr>
          <th>Icono</th>
          <th>Nombre</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-variety let-i="rowIndex">
        <tr>

          <td>
            <img
              [src]="variety.value.preview"
              width="30">
          </td>

          <td>
            {{ variety.value.name }}
          </td>

          <td>
            <button
              pButton
              icon="pi pi-trash"
              class="p-button-danger p-button-text"
              (click)="removeVariety(i)">
            </button>
          </td>

        </tr>
      </ng-template>
    </p-table>
    <div>
      <div class="flex align-items-center justify-content-start mt-3">
        <p-button
          label="{{'AdminSpeciesManagement.CreateEditSpecie.CreateButton' | translate}}"
          (onClick)="save()"
          [loading]="loading"
          styleClass="w-8rem"
          class="custom-text-button">
        </p-button>
      </div>
    </div>
  </form>
</div>

